import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class ODataFilterService {
  public translateFilterToOData(
    field: string,
    op: string,
    value: string | string[],
    filterType: string
  ): string {
    const values = [].concat(value)
    let val = values[0]
    let val2 = ''

    field = field.replace(/\./g, '/')

    if (op === 'inrange') {
      if (!val) {
        op = 'lessthanorequal'
        val = values[1]
      } else {
        if (!values[1]) {
          op = 'greaterthanorequal'
        }
      }
      val2 = values[1]
    }

    if (filterType === 'agTextColumnFilter') {
      val = `'${val.toLowerCase()}'`
      field = `tolower(${field})`
    } else if (filterType === 'boolFilter') {
      val = `${(val === 'true').toString()}`
    } else if (
      filterType !== 'agNumberColumnFilter' &&
      filterType !== 'agDateColumnFilter' &&
      !['any', 'in'].includes(op) &&
      val &&
      isNaN(Number(val))
    ) {
      val = `'${val.toString().toLowerCase()}'`
      field = `tolower(${field})`
    }

    if (filterType === 'agNumberColumnFilter') {
      if (!val.toString().includes('.')) {
        val = `cast(${val}, 'Edm.Int64')`
      } else {
        val = `cast(${val}, 'Edm.Decimal')`
      }

      if (val2) {
        if (!val2.toString().includes('.')) {
          val2 = `cast(${val2}, 'Edm.Int64')`
        } else {
          val2 = `cast(${val2}, 'Edm.Decimal')`
        }
      }
    }

    if (!val.toString().length && filterType !== 'agTextColumnFilter') {
      return ''
    }

    switch (op) {
      case 'equals':
        return `${field} eq ${val}`
      case 'notequal':
        return `${field} ne ${val}`
      case 'contains':
      case 'startswith':
      case 'endswith':
        return `${op}(${field}, ${val})`
      case 'greaterthan':
        return `${field} gt ${val}`
      case 'greaterthanorequal':
        return `${field} ge ${val}`
      case 'lessthan':
        return `${field} lt ${val}`
      case 'lessthanorequal':
        return `${field} le ${val}`
      case 'inrange':
        return `${field} ge ${val} and ${field} le ${val2}`
      case 'notcontains':
        return `not contains(${field}, ${val})`
      case 'any':
        return `${field}/any(${val})`
      case 'in':
        return `${field} in (${val})`
      default:
        return ''
    }
  }
}
